import script from "./AcademicStaticsticsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicStaticsticsIndex.vue?vue&type=script&setup=true&lang=js"

import "./AcademicStaticsticsIndex.vue?vue&type=style&index=0&id=e2d6e968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2d6e968"]])

export default __exports__